import React, { useState } from "react";
import moment from 'moment';
import {
  Form,
  Input,
  Modal,
  Button,
  Select,
  Steps,
  Typography,
  Rate,
  message,
  DatePicker,
} from "antd";


const {TextArea} = Input;

const initialValues = {
  display_name: "", 
  first_name: "", 
  last_name: "", 
  user_id: "", 
  sex: "", 
  user_short_bio: "",
  state: "",
};

interface Values {
  display_name: string, 
  first_name: string, 
  last_name: string, 
  user_id: string, 
  sex: string, 
  user_short_bio: string,
  state: string,
}

interface UserProfileUpdateFormProps {
  id: string;
  visible: boolean;
  product: any;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}

export const UserProfileUpdateModal: React.FC<UserProfileUpdateFormProps> = ({
  id,
  visible,
  product,
  onCreate,
  onCancel,
}) => {
  initialValues.user_id = id;
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);

  function disabledDate(current: any) {
    // Can not select days before today and today
    return current > moment().subtract(21, 'years')
  }
  const { Step } = Steps;

  const steps = [{}];

  return (
    <Modal
      visible={visible}
      title="Update your User Profile"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={initialValues}
      >
        {" "}
        <div style={{ display: current === 0 ? "block" : "none" }}>
          <Typography.Title level={5}>Let us know a little about you to best determine recommendations. Filling in Date of bith is required to start loggin.</Typography.Title>
          <br />
          <Form.Item name="display_name" label="Display Name">
            <Input type="text" />
          </Form.Item>
          {/* <Form.Item name="first_name" label="First Name">
            <Input type="text" />
          </Form.Item>
          <Form.Item name="last_name" label="Last Name">
            <Input type="text" />
          </Form.Item> */}
          
          <Form.Item
            name="sex"
            label="Sex (M/F/O)"
          >
            <Select>
              <Select.Option
                value={"Male"}
              >
                Male
              </Select.Option>
              <Select.Option
                value={"Female"}
              >
                Female
              </Select.Option>
              <Select.Option
                value={"Other"}
              >
                Other
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="state"
            label="Location"
            rules={[
              { required: true, message: "Please select your birth day" },
            ]}
          >
            <Select>
              <Select.Option
                value={"puerto rico"}
              >
                Puerto Rico
              </Select.Option>
              <Select.Option
                value={"other"}
              >
                Other
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item required name="dob" label="Date of Birth"
            rules={[
              { required: true, message: "Please select your date of birth" },
            ]}>
            <DatePicker disabledDate={disabledDate}	defaultValue={moment('2000-01-01', 'YYYY-MM-DD')}/>
          </Form.Item>
          {/* <Form.Item name="user_short_bio" label="Short Bio">
            <TextArea autoSize={{ minRows: 4, maxRows: 8 }}/>
          </Form.Item> */}
          <br/>
        </div>
            <Button
              type="primary"
              style={{width: '100%', margin: '0 auto', display: 'block'}}
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    const newValues = values;
                    form.resetFields();
                    onCreate(newValues)
                    message.success("Profile Updated!");
                  })
                  .catch((info) => {
                    console.log("Validate Failed:", info);
                  });
              }}
            >
              Submit
            </Button>
      </Form>
    </Modal>
  );
};
